import Api from "../Api/Api";

export const getAdmin = (data) => {
  return Api.post(`user/login`, data,{headers: { Platform: "Web"}});
};